import moment from "moment";
import CONFIG from "../config/config";
import ROUTES from "../common/routes";

const getDomain = () => {
    const domain = window.sessionStorage.getItem("domain");
    return domain ? JSON.parse(domain) : null;
};

const getFormattedDateTime = (dateString) => {
    const date = moment(dateString);

    return date.isValid() ? date.local().format(CONFIG.DATE_TIME_FORMAT) : "";
};

const getInitials = (name) => {
    const nameArray = name.trim().split(" ").slice(0, 2);
    const initials = nameArray.map((el) => el && el[0].toUpperCase());
    return initials.join("");
};

const isEmpty = (obj) => {
    for (let i in obj) {
        return false;
    }
    return true;
};

const LOGIN_PAGE_URL = ROUTES.LOGIN;
const VERIFY_PAGE_URL = ROUTES.VERIFY;
const RESET_PASSWORD_PAGE_URL = ROUTES.RESET_PASSWORD;

const isPrivatePage = () =>
    [VERIFY_PAGE_URL, LOGIN_PAGE_URL, RESET_PASSWORD_PAGE_URL].some((url) =>
        window.location.href.includes(url)
    );

const routeToLoginPage = () => {
    window.sessionStorage.clear();
    window.location.href = LOGIN_PAGE_URL;
};

const generateId = () => {
    const S4 = () => {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };

    return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
    );
};

const numberCompareFn = (a, b) => {
    return a - b;
};

const triggerDownloadJsonData = ({ data, fileName }) => {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);

    // create "a" HTLM element with href to file
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

const getUrlParams = ({
    size,
    prev,
    firstCursor,
    lastCursor,
    getLatest,
    extraQuery = {}
}) => {
    const queryParams = [];

    if (size) {
        queryParams.push("size=" + size);
    }

    if (prev) {
        queryParams.push("cursor=" + firstCursor, "prev=true");
    } else if (lastCursor) {
        queryParams.push("cursor=" + lastCursor);
    }

    if (getLatest) {
        queryParams.push("getLatest=true");
    }

    Object.keys(extraQuery).forEach((key) => {
        if (extraQuery[key] !== undefined && extraQuery[key] !== "") {
            queryParams.push(`${key}=${extraQuery[key]}`);
        }
    });

    return queryParams.length ? `?${queryParams.join("&")}` : "";
};

const getSourceUrls = () => {
    return [
        { url: "https://coeptis-dev.onthemovesw.com", title: "Configure-Dev" },
        { url: "https://coeptis-test.onthemovesw.com", title: "Configure-Test" },
        { url: "https://coeptis-prod.onthemovesw.com", title: "Configure-Prod" },
        { url: "https://coeptis-internal.onthemovesw.com", title: "Configure-Internal" }
    ];
};

const getDeploymentUrl = (deployment) => {
    if (!deployment) return null;
    return `https://${deployment.cname ? deployment.cname : deployment.otmApp?.cloudfrontUrl}${deployment.homePage}`
}

const refreshBuildTimeConfig = (deploymentId) => {
    window.sessionStorage.removeItem(`buildTimeConfig_${deploymentId}`);
    window.sessionStorage.removeItem(`initialBuildTimeConfig_${deploymentId}`);
    window.sessionStorage.removeItem(`templateConfig_${deploymentId}`);
    window.sessionStorage.removeItem(`templateMetadata_${deploymentId}`);
}

const Utils = {
    getDomain,
    getFormattedDateTime,
    getInitials,
    isEmpty,
    routeToLoginPage,
    isPrivatePage,
    generateId,
    numberCompareFn,
    triggerDownloadJsonData,
    getUrlParams,
    getSourceUrls,
    getDeploymentUrl,
    refreshBuildTimeConfig    
};

export default Utils;
